import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import classNames from 'classnames';


class CreditCardImage extends React.PureComponent {
  render() {
    const {cardType, className} = this.props;
    const typeName = 'card_' + cardType;
    return (
      <div className={classNames(styles[typeName],className)}/>
    )
  }
}

CreditCardImage.propTypes = {
  cardType: PropTypes.oneOf([
    "AMEX", "DINERS", "DISCOVER", "MC", "VISA"
  ])
};

export default CreditCardImage;
